'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AUIIcon = require('./AUIIcon');

var _AUIIcon2 = _interopRequireDefault(_AUIIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AUIButton = function AUIButton(_ref) {
    var icon = _ref.icon,
        type = _ref.type,
        disabled = _ref.disabled,
        children = _ref.children,
        className = _ref.className,
        otherProps = _objectWithoutProperties(_ref, ['icon', 'type', 'disabled', 'children', 'className']);

    var iconComponent = null;

    if (icon) {
        iconComponent = _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_AUIIcon2.default, { icon: icon }),
            '\xA0'
        );
    }

    var typeClass = void 0;

    if (type) {
        typeClass = 'aui-button-' + type;
    }

    var classes = (0, _classnames2.default)('aui-button', typeClass, className);

    return _react2.default.createElement(
        'button',
        _extends({ className: classes, 'aria-disabled': disabled }, otherProps),
        iconComponent,
        children
    );
};

AUIButton.displayName = 'AUIButton';
AUIButton.defaultProps = {
    className: ''
};

AUIButton.propTypes = {
    /**
     * The type of the button link, primary or subtle
     */
    type: _propTypes2.default.oneOf(['link', 'primary', 'subtle']),
    /**
     * The icon to show in the button
     */
    icon: _propTypes2.default.string,
    /**
     * Disabled
     */
    disabled: _propTypes2.default.bool,
    /**
     * The children of the button
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    className: _propTypes2.default.string
};

exports.default = AUIButton;
//# sourceMappingURL=AUIButton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIButton.js
// module id = 176
// module chunks = 0